module.exports = __webpack_public_path__ + "img/award2020-02.95ec1cae.png";